import { Container } from 'pixi.js';

export class ParticlesView {
    containersMap;
    options;

    constructor(options) {
        this.options = options;
        this.containersMap = new Map();

        for (const effectName in this.options.systemConfig) {
            const container = new Container();
            container.name = `Particles_${effectName}`;
            this.containersMap.set(effectName, container);
        }
    }

    addToContainers(targetContainersMap = {}) {
        for (const [effectName, parentContainer] of Object.entries(targetContainersMap)) {
            const particleContainer = this.getContainer(effectName);

            if (particleContainer && parentContainer) {
                parentContainer.addChild(particleContainer);
            } else if (this.options.isStage) {
                console.warn(
                    `[ParticlesView] Ошибка добавления: Эффект "${effectName}" или его родительский контейнер не найден.`
                );
            }
        }
    }

    addToContainerInRunTime(container, effectName) {
        const particleContainer = this.getContainer(effectName);
        if (particleContainer && container) {
            container.addChild(particleContainer);
        } else if (this.options.isStage) {
            console.warn(
                ` [ParticlesView] Не удалось добавить "${effectName}" в runtime. Контейнер отсутствует.`
            );
        }
    }

    getContainer(effectName) {
        return this.containersMap.get(effectName);
    }

    destroy() {
        for (const container of this.containersMap.values()) {
            container.destroy({ children: true });
        }
        this.containersMap.clear();
    }
}